import { render, staticRenderFns } from "./stuSkipList.vue?vue&type=template&id=beab532e&"
import script from "./stuSkipList.vue?vue&type=script&lang=js&"
export * from "./stuSkipList.vue?vue&type=script&lang=js&"
import style0 from "./stuSkipList.vue?vue&type=style&index=0&id=beab532e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports